// @flow
import * as React from 'react';
import Notice from 'sail/Notice';
import {motion, AnimatePresence} from 'framer-motion';

type ApiWorksheetProps = {|
  children: React.Node,
  title: String,
|};

export const Complete = ({children, title}: ApiWorksheetProps) => {
  return (
    <AnimatePresence>
      <motion.div
        key="complete"
        initial={{x: 300, opacity: 0}}
        animate={{x: 0, opacity: 1, transition: {duration: 0.75}}}
        exit={{x: -300, opacity: 0}}
      >
        <Notice
          color="green"
          divider={false}
          title={title}
          description={children}
        />
      </motion.div>
    </AnimatePresence>
  );
};
